import Text from '@axa-japan/design-system-react/Text';
import { useEffect } from 'react';
import UrlWatcher from '../components/UrlWatcher';
import { handleBeforeUnload, handlePostState } from '../utils/leavePageWarning';

const ExitPage = () => {
  useEffect(() => {
    handlePostState();

    // Remove browser button click event listener
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });

  return (
    <div className="grid h-full w-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div>
        <svg
          className="w-12 h-12 text-gray"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <UrlWatcher />
      <Text size="lg" weight="regular" align="center">
        終了しました。画面を閉じてください。
      </Text>
      <Text size="lg" weight="regular" align="center">
        再度、撮影・送信を行う場合は、始めからやり直してください。
      </Text>
    </div>
  );
};

export default ExitPage;
